module.exports = __webpack_public_path__ + "img/Lili Feyerabend.0db6ed7d.jpg";